module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mb-1 dark:text-white"
  }, [_c('span', {
    style: (_vm.textColorStyle)
  }, [_vm._v(_vm._s(_vm.percentage) + "%")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.textAbout))])]), _vm._v(" "), _c('div', {
    staticClass: "w-full bg-gray-200 dark:bg-gray-700"
  }, [_c('div', {
    staticClass: "bg-gray-500 dark:bg-gray-300",
    style: (_vm.progressBarStyle)
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-c5599062!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/summaryComponents/ProgressiveBar.vue
// module id = 1125
// module chunks = 61